const getNDaysBefore = (dateTime: string, days: number) => {
  const d = new Date(dateTime);
  const nDaysBefore = d.setDate(d.getDate() - days);
  return new Date(nDaysBefore);
};

export default getNDaysBefore;
